import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormRelacionesLaborales, { normalizeRelacionLaboralBoolean } from 'components/blocks/ManagementNewForms/Inputs/FormRelacionesLaborales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import useCreatetRiesgoEmbarazoLactancia from 'services/record/RiesgoEmbarazoLactancia/useCreateRiesgoEmbarazoLactancia';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import useUpdateRiesgoEmbarazoLactanciaByID from 'services/record/RiesgoEmbarazoLactancia/useUpdateRiesgoEmbarazoLactanciaByID';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormCausasREL from 'components/blocks/ManagementNewForms/Inputs/FormCausasREL';
import FormInputYesNo from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputYesNo';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInfoSolicitudesDependientes from 'components/blocks/ManagementNewForms/Inputs/FormInfoSolicitudesDependientes';


const SolicitudRiesgoEmbarazoLactancia = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {

  const [totalSize, setTotalSize] = useState(0);
  const MAX_SIZE_MB = 30;
  const formMethods = useForm();
  const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, resetField, control, getValues } = formMethods;
  const { createRiesgoEmbarazoLactancia, dataRiesgoEmbarazoLactancia, loadingRiesgoEmbarazoLactancia, successRiesgoEmbarazoLactancia, errorRiesgoEmbarazoLactancia } = useCreatetRiesgoEmbarazoLactancia();
  const { updateRiesgoEmbarazoLactanciaById, loadingUpdateRiesgoEmbarazoLactanciaById, successUpdateRiesgoEmbarazoLactanciaById, errorUpdateRiesgoEmbarazoLactanciaById, dataUpdateRiesgoEmbarazoLactanciaById } = useUpdateRiesgoEmbarazoLactanciaByID();
  const [datosAPI, setDatosAPI] = useState(dataUser);
  const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);
  const [contingenciaCausaREL, setContingenciaCausaREL] = useState<8 | 9 | null>(null);
  const watchRiesgoEmbarazoLactancia = watch('MotivoSolicitud.RiesgoEmbarazoLactancia');
  const previousRiesgoEmbarazoLactanciaRef = React.useRef<string | null>(null);
  const isHydratingFormRef = React.useRef<boolean>(false);

  const adaptApiResponseToDefaultValues = (data: any) => {
    console.log(data)
    if (data) {
      isHydratingFormRef.current = true;
      const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
      const datosPersonales = getValue(data?.DatosPersonales, data?.datosPersonales) || {};
      const procesosIT = getValue(data?.ProcesoITRelacion, data?.procesoITRelacion, data?.ProcesosIT, data?.procesosIT) || [];
      const documentacion = getValue(
        data?.SeccionesDocumentacion,
        data?.seccionesDocumentacion,
        data?.Documentacion,
        data?.documentacion
      ) || [];
      const motivoSolicitud = data?.MotivoSolicitud
      const causaSolicitudRELCodigo = getValue(data?.CausaSolicitudRELCodigo, data?.causaSolicitudRELCodigo);
      const iban = getValue(data?.IBAN, data?.iban);
      reset({
        ProcesosIT: {
          TieneProcesosIT: data?.TieneProcesosIT,
          IT: fillArray(procesosIT, 2, {
            Id: null,
            ExternalId: 0,
            formularioSReconocimientoRelId: null,
            FechaBaja: '',
            FechaAlta: '',
            Relacion: ''
          }).map((it: any) => ({
            ...it,
            Id: getValue(it?.Id, it?.id),
            ExternalId: getValue(it?.ExternalId, it?.externalId, 0),
            formularioSReconocimientoRelId: getValue(
              it?.formularioSReconocimientoRelId,
              it?.FormularioSReconocimientoRelId,
              it?.formSolReconocimientoRELId,
              it?.FormSolReconocimientoRELId
            ),
            FechaBaja: getValue(it?.FechaBaja, it?.fechaBaja, ''),
            FechaAlta: getValue(it?.FechaAlta, it?.fechaAlta, ''),
            Relacion: getValue(it?.Relacion, it?.relacion, ''),
          })),
        },

        DatosEmpresa: {
          RiesgoEmbarazoLactancia: motivoSolicitud !== undefined && motivoSolicitud !== null ? motivoSolicitud.toString() : "",
          EmpresaNombre: getValue(data?.EmpresaNombre, data?.empresaNombre, null),
          EmpresaCCC: getValue(data?.EmpresaCCC, data?.empresaCCC, null),
          EmpresaNAF: getValue(data?.EmpresaNAF, data?.empresaNAF, data?.NAF, data?.naf, null),
          EmpresaCIF: getValue(data?.EmpresaCIF, data?.empresaCIF, data?.CIF, data?.cif, null),
          EsAutonomo: normalizeRelacionLaboralBoolean(getValue(data?.EsAutonomo, data?.esAutonomo, null)),
          RelacionLaboralId: null,
          DescripcionAdaptacionPuesto: getValue(data?.DescripcionAdaptacionPuesto, data?.descripcionAdaptacionPuesto, ""),
        },
        MotivoSolicitud: {
          RiesgoEmbarazoLactancia: motivoSolicitud !== undefined && motivoSolicitud !== null ? motivoSolicitud.toString() : "",
          FechaSuspension: getValue(data?.FechaSuspension, data?.fechaSuspension, null),
          DescripcionAdaptacionPuesto: getValue(data?.DescripcionAdaptacionPuesto, data?.descripcionAdaptacionPuesto, ""),
        },
        DatosPersonales: {
          SolicitanteNombre: getValue(datosPersonales?.Nombre, datosPersonales?.nombre, ""),
          SolicitanteApellido1: getValue(datosPersonales?.Apellido1, datosPersonales?.apellido1, ""),
          SolicitanteApellido2: getValue(datosPersonales?.Apellido2, datosPersonales?.apellido2, ""),
          SolicitanteIPF: getValue(datosPersonales?.IPF, datosPersonales?.ipf, ""),
          SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo, datosPersonales?.ipfTipo)?.toString() || "1",

          SolicitanteTelefono: getValue(datosPersonales?.Telefono, datosPersonales?.telefono, ""),
          SolicitanteFijo: getValue(datosPersonales?.Fijo, datosPersonales?.fijo, ""),
          SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, datosPersonales?.domicilio, ""),
          SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, datosPersonales?.codigoPostal, ""),
          SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, ""),
          SolicitanteProvinciaDescripcion: getValue(datosPersonales?.Provincia, datosPersonales?.ProvinciaDescripcion, datosPersonales?.provinciaDescripcion, ""),
          SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, datosPersonales?.codigoLocalidad, ""),
          SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, datosPersonales?.localidadDescripcion, ""),
          SolicitanteEmail: getValue(data?.Email, data?.email, ""),
          SolicitanteFechaNacimiento: getValue(data?.FechaNacimiento, data?.fechaNacimiento, ""),
          SolicitanteNumeroSS: getValue(datosPersonales?.NumeroSeguridadSocial, datosPersonales?.numeroSeguridadSocial, ""),
          SolicitanteIRPF: getValue(data?.TipoIRPFVoluntario, data?.tipoIRPFVoluntario, ""),
        },
        CausaSolicitud: {
          CausaREL: causaSolicitudRELCodigo,
        },
        DatosBancarios: {
          SolicitanteIBAN: iban ? iban.replace(/-/g, '') : "",
        },
        Documentacion: adaptDocumentacion(documentacion),
        Acepto: getValue(data?.Acepto, data?.acepto, false)
      });

      setTimeout(() => {
        previousRiesgoEmbarazoLactanciaRef.current = String(
          getValues('MotivoSolicitud.RiesgoEmbarazoLactancia') ?? ""
        );
        isHydratingFormRef.current = false;
      }, 0);
    }

  }

  useEffect(() => {
    adaptApiResponseToDefaultValues(dataUser);
  }, [dataUser]);

  useEffect(() => {
    setDatosAPI(dataUser);
  }, [dataUser]);

  useEffect(() => {
    const selected = String(watchRiesgoEmbarazoLactancia ?? "");
    const previousSelected = previousRiesgoEmbarazoLactanciaRef.current;

    if (!isHydratingFormRef.current && previousSelected !== null && previousSelected !== selected) {
      resetField('CausaSolicitud.CausaREL');
      resetField('CausaSolicitud.CausaRELDescripcion');
      resetField('CausaSolicitud.CausaRELId');
    }

    if (selected === "0") {
      setContingenciaCausaREL(8);
      previousRiesgoEmbarazoLactanciaRef.current = selected;
      return;
    }

    if (selected === "1") {
      setContingenciaCausaREL(9);
      previousRiesgoEmbarazoLactanciaRef.current = selected;
      return;
    }

    setContingenciaCausaREL(null);
    previousRiesgoEmbarazoLactanciaRef.current = selected;
  }, [watchRiesgoEmbarazoLactancia]);


  const hasValue = (value: any) => value !== null && value !== undefined && value !== '';

  const validateProcesosIT = (rows: any[] = []) => {
    if (!Array.isArray(rows)) return true;

    for (const row of rows) {
      const hasFechaBaja = hasValue(row?.FechaBaja);
      const hasFechaAlta = hasValue(row?.FechaAlta);
      const hasRelacion = hasValue(row?.Relacion);

      if ((hasFechaBaja || hasFechaAlta) && !hasRelacion) {
        return 'Si rellena Fecha baja o Fecha alta, debe indicar la relación con el embarazo';
      }
    }

    return true;
  };




  const onSubmit = async (data: any) => {
    console.log(data)
    setLoader(true);

    let prestacionId = dataUser?.PrestacionId || null;
    const procesosITFiltrados = (data?.ProcesosIT?.IT ?? []).filter((it: any) => {
      const hasFechaBaja = hasValue(it?.FechaBaja);
      const hasFechaAlta = hasValue(it?.FechaAlta);
      const hasRelacion = hasValue(it?.Relacion);
      return hasFechaBaja || hasFechaAlta || hasRelacion;
    });
    const esAutonomo = normalizeRelacionLaboralBoolean(data?.DatosEmpresa?.EsAutonomo);

    const datosEnvio = {
      Acepto: true,
      Id: dataUser.Id,
      PersonaId: dataUser.PersonaId,
      UsuarioId: dataUser.UsuarioId,
      CodigoExpediente: dataUser.CodigoExpediente,
      ExpedienteId: dataUser.ExpedienteId || null,
      PrestacionId: prestacionId,

      // ----- DATOS PERSONALES -----
      DatosPersonales: {
        Nombre: data?.DatosPersonales?.SolicitanteNombre || "",
        Apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
        Apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
        IPF: data?.DatosPersonales?.SolicitanteIPF || "",
        IPFTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,

        Telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
        Fijo: data?.DatosPersonales?.SolicitanteFijo || "",
        Domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
        CodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
        ProvinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
        CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,
        NumeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || "",
        CodigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
        LocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,

      },
      Email: data?.DatosPersonales?.SolicitanteEmail || "",

      FechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || "",
      TipoIRPFVoluntario:
        data?.DatosPersonales?.SolicitanteIRPF
          ? Number(data?.DatosPersonales?.SolicitanteIRPF)
          : null,
      // ----- DATOS EMPRESA -----
      EsAutonomo: esAutonomo,
      EmpresaNombre: data?.DatosEmpresa?.EmpresaNombre ?? null,
      EmpresaCCC: esAutonomo === true ? null : data?.DatosEmpresa?.EmpresaCCC ?? null,
      CIF: esAutonomo === true ? null : data?.DatosEmpresa?.EmpresaCIF ?? null,
      NAF: esAutonomo === false ? null : data?.DatosEmpresa?.EmpresaNAF ?? null,
      MotivoSolicitud: parseInt(data?.MotivoSolicitud?.RiesgoEmbarazoLactancia) ?? null,
      DescripcionAdaptacionPuesto: data?.MotivoSolicitud?.DescripcionAdaptacionPuesto ?? null,
      FechaSuspension: data?.MotivoSolicitud?.FechaSuspension === "" ? null : data?.MotivoSolicitud?.FechaSuspension,
      CausaSolicitudRELCodigo: data?.CausaSolicitud.CausaREL ?? null,
      // ----- DATOS BANCARIOS -----
      IBAN: data?.DatosBancarios?.SolicitanteIBAN
        ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,
      // ----- PROCESOS IT -----
      // ProcesoIT: data?.ProcesosIT?.IT?.length > 0 ? true : false,
      TieneProcesosIT: data?.ProcesosIT?.TieneProcesosIT ?? null,
      ProcesosIT: procesosITFiltrados.map((it: any) => ({
        Id: it?.Id ?? null,
        ExternalId: it?.ExternalId ?? 0,
        FormularioSReconocimientoRelId: it?.formularioSReconocimientoRelId ?? null,
        FechaBaja: it?.FechaBaja || null,
        FechaAlta: it?.FechaAlta || null,
        Relacion: it?.Relacion ?? null
      })),

      // ----- DOCUMENTACION -----
      Documentacion: await prepareDocumentacionArrayWithCase(data?.Documentacion ?? data?.SeccionesDocumentacion ?? [])
    };

    console.log("DatosEnvio", datosEnvio)

    if (info) {
      createRiesgoEmbarazoLactancia(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
      setBloquearEnvio(true);

    } else {
      updateRiesgoEmbarazoLactanciaById(dataUser?.Id, dataUser?.Id, datosEnvio)
      setBloquearEnvio(true);
    }


    setTimeout(() => {
      setLoader(false); //tiempo cargar DOM
    }, 500);
  };





  return (
    <FormProvider {...formMethods}>
      <div className="container form--simple-styled" id="formDeltawithoutleave">

        {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
        <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

        <Loader activeLoader={loader || loadingRiesgoEmbarazoLactancia || loadingUpdateRiesgoEmbarazoLactanciaById} label="Cargando Formulario"></Loader>








        {/* ////////////// COMIENZO FORMULARIO ////////////// */}


        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>IMPORTANTE: El certificado médico que solicita justificará, en su caso, la necesidad de puesto de trabajo o de las funciones
          que realiza. Sólo si dicho cambio no se produce por los motivos previstos legalmente, podrá acceder con posterioridad a la
          prestación de riesgo durante el embarazo la lactancia natural. </p>


        {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
        <FormInfoCreateUpdate
          isCreate={info}
          estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
          estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
          fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
        />
        <FormDatosPersonales activarFechaNacimiento={true} activarSS={true} emailVisible={true} activarIRPF={true} validarMinimoIRPF={true} />

        <AccordionForm title={'Datos de la Empresa'} expandedInit={false} nombreError='DatosEmpresa' >
          <div className="row mb-4">
            <div className="col-xl-12">


              <FieldsetContainer legend="" disabled={false}>
                <FormRelacionesLaborales
                  info={info}
                  names={{
                    nombreEmpresa: 'DatosEmpresa.EmpresaNombre',
                    ccc: 'DatosEmpresa.EmpresaCCC',
                    naf: 'DatosEmpresa.EmpresaNAF',
                    cif: 'DatosEmpresa.EmpresaCIF',
                    esAutonomo: 'DatosEmpresa.EsAutonomo',
                  }}
                  labels={{
                    selector: 'Entorno laboral',
                    nombreEmpresa: 'Nombre o Razón Social',
                    ccc: 'Código Cuenta Cotización',
                    naf: 'NAF',
                    cif: 'CIF',
                  }}
                  selectorName='DatosEmpresa.RelacionLaboralId'
                  relacionesLaborales={
                    datosAPI?.RelacionLaboral ?? datosAPI?.relacionLaboral ?? []
                  }
                  md={6}
                  xl={6}
                />




              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>


        <AccordionForm title={'Motivo de la Solicitud'} expandedInit={false} nombreError='MotivoSolicitud' >
          <div className="row mb-4">
            <div className="col-xl-12">
              <FieldsetContainer legend="" disabled={false}>
                <FormInputRadioGroup
                  title=' Solicito el certificado médico sobre la necesidad de cambio de puesto de trabajo o de funciones compatibles con mi estado por:'
                  labels={['Riesgo durante el Embarazo', 'Riesgo durante la Lactancia']}
                  name={'MotivoSolicitud.RiesgoEmbarazoLactancia'}
                  required='Debe seleccionar una opción como mínimo'
                  modal={['Riesgo durante el embarazo, ya que las condiciones del puesto de trabajo influyen negativamente en mi salud y/o en la del feto', 'Riesgo durante la lactancia natural, ya que las condiciones del puesto de trabajo influyen negativamente en mi saludo y/o en la del feto']}
                />
                <div className='mt-2'></div>
                <FormInputFecha
                  name={'MotivoSolicitud.FechaSuspension'}
                  id={'MotivoSolicitud.FechaSuspension'}
                  label={'Fecha suspensión contrato o cese actividad'} placeholder={''} md={12} xl={12} col={12}
                  maxDate={new Date(Date.now())}
                  disableDate={false}
                />
                <div className="col-xl-12 col-md-12">
                  <TextAreaDefault
                    id='MotivoSolicitud.DescripcionAdaptacionPuesto'
                    name='MotivoSolicitud.DescripcionAdaptacionPuesto'
                    label='Si ha existido adaptación del puesto de trabajo, describa cómo se ha producido:'
                    placeholder=""

                  />
                </div>





              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>

        <AccordionForm title={'Causa de la Solicitud'} expandedInit={false} nombreError='CausaSolicitud' >
          <div className="row mb-4">
            <div className="col-xl-12">
              <FieldsetContainer legend="" disabled={false}>
                <FormCausasREL
                  name="CausaSolicitud.CausaREL"
                  contingenciaId={contingenciaCausaREL}
                  required="Debe seleccionar una causa"
                  xl={12}
                  md={12}
                  col={12}
                />
              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>

        <AccordionForm title={'Procesos de IT ultimos 6 meses'} expandedInit={false} nombreError='ProcesosIT' >
          <div className="row mb-4">
            <div className="col-xl-12">

              <FormInputYesNo
                name="ProcesosIT.TieneProcesosIT"
                title="Ha tenido procesos de IT en los últimos 6 meses"
                required='Debe declarar si ha tenido procesos de IT'
              />

              <AccordionDisplay dataUser={dataUser} visibility={watch('ProcesosIT.TieneProcesosIT') === true} fields={[]}>
                <FormInputTable
                  name="ProcesosIT.IT"
                  heads={["Baja", "Alta", "Relacion con el Embarazo"]}
                  nameHeads={["FechaBaja", "FechaAlta", "Relacion"]}
                  removeButton={false}
                  addButton={false}
                  widthColumn={[1, 1, 2]}
                  validateFunction={validateProcesosIT}
                  inputType={[4, 4, 5]}
                  arrayModal={[null, "", null, ""]}
                />
              </AccordionDisplay>



            </div>
          </div>
        </AccordionForm>

        <AccordionForm title={'Datos Bancarios'} expandedInit={false} nombreError='DatosBancarios' >
          <div className="row mb-4">
            <div className="col-xl-12">

              <div className="row mb-4">
                <div className="col-xl-12">

                  <FormInputCuentaBancaria
                    id='DatosBancarios.SolicitanteIBAN'
                    name='DatosBancarios.SolicitanteIBAN'
                    xl={12}
                    md={12}
                    placeholder=''
                    req='Falta el Número de Cuenta Bancaria'

                  />
                </div>
              </div>

            </div>
          </div>
        </AccordionForm>

        <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
          <div className="row mb-4">
            <div className="col-xl-12">
              <FormArrayArchivosReducidos
                name={'Documentacion'}
                urlArchivos={dataUser?.Documentacion?.map(d => d?.SasUri) || []}
                setTotalSize={setTotalSize}
              />

            </div>
          </div>
        </AccordionForm>












        {/* ////////////// FINAL FORMULARIO ////////////// */}

        <FormInfoSolicitudesDependientes data={dataUser} />
        {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
        <FormBotonSubmit
          disableSubmit={bloquearEnvio}
          onSubmit={handleSubmit(onSubmit)}
          successCreate={successRiesgoEmbarazoLactancia}
          successUpdate={successUpdateRiesgoEmbarazoLactanciaById}
          errorCreate={errorRiesgoEmbarazoLactancia}
          errorUpdate={errorUpdateRiesgoEmbarazoLactanciaById}
          datosAPI={datosAPI}
          info={info}
          MaxSizeMB={MAX_SIZE_MB}
          totalSizeDocs={totalSize}
        />


        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
          que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
          fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
        </p>

        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
          personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
          cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
          podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
          escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
          debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
        </p>



      </div>
    </FormProvider>
  )
}

export default SolicitudRiesgoEmbarazoLactancia



